// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"_3WrS6ULmTLwgVjTCbKcsKJ"};